<template>
    <div class="w100 bgGrey">
        <article class="wContent center">
            <div class="mw-modular-box bgWhite p20" style="min-height: 460px;">
                <p style="border-bottom: 1px solid #ccc; padding-bottom: 15px;" class="font14"><span class="fontBold font16">{{ '“' + key + '”' }}</span> 相关内容</p>
                <div v-show="!none">
                    <div class="part-tab-clist pointer" v-for="(item, index) in report_list" :key="index" @click="goDetailPage(item.reportId)">
                        <div class="inlineBlock vTop">
                            <img src="../../assets/images/report_fx_pz.png" style="width: 147px;" alt srcset v-if="item.sortName == '唐宋100指数报告-分品种'"/>
                            <img src="../../assets/images/report_fx.png" style="width: 147px;" alt srcset v-else-if="item.sortName == '唐宋100指数（周）报告'" />
                            <img src="../../assets/images/report_tejrb.png" style="width: 147px;" alt srcset v-else-if="item.sortName == '唐尔街日报'" />
                            <img src="../../assets/images/report_hysd.png" style="width: 147px;" alt srcset v-else-if="item.sortName == '监测预警周报'" />
                            <img src="../../assets/images/report_fx_pz.png" style="width: 147px;" alt srcset v-else />
                        </div>
                        <div class="w100 textLeft main inlineBlock vTop" style="max-width: fit-content;">
                            <h4 class="font16 fontBold fontNormal">{{ item.reportTitle }}</h4>
                            <div class="main-sub fontLight">{{ item.abstractText }}</div>
                            <div class="main-tags-box">
                                <span class="main-tag fontRed">{{ item.sortName }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-for="(item, index) in consult_sel_all" :key="index">
                        <div class="part-tab-clist pointer" v-show="item.pic" @click="goDetailPage(item.primary_id)">
                            <span class="tag">{{ item.type_name }}</span>
                            <div style="flex: 1; max-width: 147px;"> <img :src="'data:image/jpeg;base64,' + item.pic" alt="" srcset="" > </div>
                            <div style="flex: 4; max-width: none;" class="w100 textLeft main">
                                <h4 class="font16 fontBold fontNormal">{{ item.the_title }}</h4>
                                <div class="main-sub fontLight">{{ item.overview }}</div>
                                <div class="main-tags-box">
                                    <span v-if="item.the_table">
                                        <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                            <span class="main-tag fontRed pointer" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                        </span>
                                    </span>
                                    <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span>{{ compareTime(item.create_date) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="part-tab-clist pointer" v-show="!item.pic" @click="goDetailPage(item.primary_id)">
                            <span class="tag">{{item.type_name}}</span>
                            <div class="w100 textLeft main" style="padding-left: 10px; max-width: none;">
                                <h4 class="font16 fontBold fontNormal" style="margin-left: 70px">{{ item.the_title }}</h4>
                                <div class="main-sub fontLight">{{ item.overview }}</div>
                                <div class="main-tags-box">
                                    <span v-if="item.the_table">
                                        <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                            <span class="main-tag fontRed pointer" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                        </span>
                                    </span>
                                    <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span>{{ compareTime(item.create_date) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mw-modular-box textRight">
                        <el-pagination background @current-change="handleCurrentChange" :current-page="pagenum" :page-size="pernum" layout="total, prev, pager, next, jumper" :total="totalNum"></el-pagination>
                    </div>
                </div>
                <div v-show="none" class="textCenter font14" style="min-height: 645px;">暂无数据</div>
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import $ from 'jquery'
import { baseUrl, getQueryString } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'SearchPage',
    components: {ConcatsControl},
    watch: {    
        '$route' (to, from) {
            this.$router.go(0);   
        }
    },
    data () {
        return {
            key: '',
            type: '',
            pagenum:1,
            pernum: 10,
            totalNum: 0,
            report_list: [],
            consult_sel_all: [],
            none: false
        }
    },
    mounted () {
        // 初始化内容
        this.key = decodeURI(getQueryString('key')); // 点击热键进来的是 热键文本,搜索进来的是input内容
        this.type = getQueryString('type'); // 点击热键进来的是1 资讯，搜索进来的是类型
        this.init();
    },
    methods: {
        //页面操作
        init () {
            if (this.type == 1) {
                this.tNewsConsultSel();
            } else if (this.type == 2) {
                this.searchReport()
            }
        },
        // 获取列表
        searchReport () {
            const self = this;
            self.$post(`${baseUrl.online}/industria/report/searchReport/${self.pagenum}/${self.pernum}`, {reportTitle: self.key}).then(res => {
                if (res.code == 0) {
                    if (res.data.length == 0) {
                        self.none = true;
                    } else {
                        self.report_list = res.data;
                        self.totalNum = res.totalCount;
                    }
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('列表获取失败')
            })
        },
        tNewsConsultSel (param) {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy?pagenum=${self.pagenum}&pernum=${self.pernum}`,
                data: {
                    keyword: self.key
                },
                dataType: 'json',
                type: 'get', success: (res) => {
                    if (res.data.length == 0) {
                        self.none = true;
                    } else {
                        self.consult_sel_all = res.data;
                        self.totalNum = Number(res.data[0].total_num);
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯信息')
                }
            })
        },

        goDetailPage (id) {
            let routeUrl = ``;
            if (this.type == 1) {
                // this.$router.push(`/home/inforDetail/${id}`)
                routeUrl = this.$router.resolve({
                    path: `/home/inforDetail/${id}`
                });
            } else {
                // this.$router.push(`/home/reportDetail/${id}`)
                routeUrl = this.$router.resolve({
                    path: `/home/reportDetail/${id}`
                });
            }
            window.open(routeUrl.href, '_blank');
        },
        goSearchPage (name) {
            this.$router.push(`/home/searchPage?key=${name}&type=1`);
        },

        handleCurrentChange (val) {
            this.pagenum = val;
            this.init();
        },
        handleChangeSize (val) {
            this.pagenum = 1;
            this.pernum = val;
            this.init();
        },
        // 判断时间
        compareTime (date) {
            const time = new Date().getTime();
            const time_1 = new Date(date).getTime();
            const range = time - time_1;
            let time_2;
            let type = 'time';
            if (range <= 1800000) {
                time_2 = Math.floor(range / 60 / 1000);
                time_2 = time_2 < 0 ? '刚刚' : time_2 + '分钟前'
            } else if (range < 21600000 && range > 1800000) {
                if (range >= 3600000) {
                    time_2 = Math.floor(range / 60 / 60 / 1000);
                    time_2 += '小时前'
                } else {
                    time_2 = Math.floor(range / 60 / 1000);
                    time_2 += '分钟前'
                }
            } else if (range > 21600000) {
                const newDate = new Date(date);
                time_2 = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                type = 'date'
            }
            return time_2
        },
    },
}
</script>

<style scoped>
    .part-tab-clist { display: flex; position: relative; border-bottom: 1px solid #eee; padding: 15px 0 10px 0; }
    .part-tab-clist:last-child { border: 0; }
    .part-tab-clist img { width: 100%; height: 95px; }
    .part-tab-clist .tag { position: absolute; top: 20px; left: 5px; background: rgba(0, 0, 0, 0.6); color: #fff; border-radius: 5px; padding: 2px 20px; }
    .part-tab-clist .main { padding-left: 20px; padding-top: 5px; }
    .part-tab-clist .main h4 { padding-bottom: 5px; }
    .part-tab-clist .main .main-sub { 
        line-height: 20px; 
        height: 40px; 
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-bottom: 5px;
    }
    .part-tab-clist .main .main-tag {
        border: 1px solid #a30000;
        padding: 0px 5px;
    }
</style>